'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, BigIntish, ChainId } from '@morpho-org/blue-sdk';
import { memo } from 'react';
import { VaultPendingTimelockChangeGuardian, VaultPendingTimelockChangeTimelock, VaultPendingTimelockCountdown } from '@/components/VaultPage/VaultV1/VaultPendingTimelock/components';
import { StyledVaultPendingTimelock } from '@/components/VaultPage/VaultV1/VaultPendingTimelock/VaultPendingTimelock.components';
import type { GuardianMetadataItems, VaultPendingTimelockDecodedData } from './types';
interface VaultPendingTimelocksProps {
  chainId: ChainId;
  decodedData: VaultPendingTimelockDecodedData;
  functionName: string;
  validAt: BigIntish;
  address?: Address;
  currentTimelock?: BigIntish;
  currentGuardianMetadata?: GuardianMetadataItems;
}
const VaultPendingTimelocks = t0 => {
  const $ = _c(18);
  const {
    decodedData,
    chainId,
    functionName,
    validAt,
    address,
    currentTimelock,
    currentGuardianMetadata
  } = t0;
  let t1;
  if ($[0] !== address || $[1] !== chainId || $[2] !== currentGuardianMetadata || $[3] !== decodedData.__typename || $[4] !== decodedData.guardian || $[5] !== functionName) {
    t1 = decodedData.__typename === "VaultSetGuardianPendingData" && <VaultPendingTimelockChangeGuardian chainId={chainId} functionName={functionName} currentGuardian={address} currentGuardianMetadata={currentGuardianMetadata} newGuardian={decodedData.guardian.address} newGuardianMetadata={decodedData.guardian.metadata.items ?? undefined} />;
    $[0] = address;
    $[1] = chainId;
    $[2] = currentGuardianMetadata;
    $[3] = decodedData.__typename;
    $[4] = decodedData.guardian;
    $[5] = functionName;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== currentTimelock || $[8] !== decodedData.__typename || $[9] !== decodedData.timelock || $[10] !== functionName) {
    t2 = decodedData.__typename === "VaultSetTimelockPendingData" && <VaultPendingTimelockChangeTimelock functionName={functionName} timelock={decodedData.timelock} currentTimelock={currentTimelock} />;
    $[7] = currentTimelock;
    $[8] = decodedData.__typename;
    $[9] = decodedData.timelock;
    $[10] = functionName;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== validAt) {
    t3 = <VaultPendingTimelockCountdown validAt={validAt} />;
    $[12] = validAt;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t4 = <StyledVaultPendingTimelock.Container selectable={false}>{t1}{t2}{t3}</StyledVaultPendingTimelock.Container>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
export default memo(VaultPendingTimelocks);